export default __webpack_public_path__ + "static/media/search.b2f2700e.svg";